import React from 'react';

const Header = () => {
    // return (<div className="at-header">
    //     <nav className="navbar navbar-default" role="navigation">
    //         <div className="container-fluid">
    //             <div className="navbar-header">

    //                 <a className="navbar-brand" href="/">Air Traffic</a>
    //             </div>
    //             <ul className="list-inline navbar-right">
    //                 <li><a href="/">HOME</a></li>
    //             </ul>
    //         </div>
    //     </nav>

    // </div>)
    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light header2 awake" id="ftco-navbar">
                <div className="container">
                    <a className="navbar-brand" href="/">Air Traffic<span>Best Travellers</span></a>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#ftco-nav" aria-controls="ftco-nav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="oi oi-menu"></span> Menu
                    </button>

                    <div className="collapse navbar-collapse" id="ftco-nav">
                        <ul className="navbar-nav ml-auto">
                            <li className="nav-item active"><a href="/" className="nav-link">Home</a></li>
                            {/* <li className="nav-item"><a href="about.html" className="nav-link">About</a></li>
                            <li className="nav-item"><a href="destination.html" className="nav-link">Destination</a></li>
                            <li className="nav-item"><a href="hotel.html" className="nav-link">Hotel</a></li>
                            <li className="nav-item"><a href="blog.html" className="nav-link">Blog</a></li>
                            <li className="nav-item"><a href="contact.html" className="nav-link">Contact</a></li> */}
                        </ul>
                    </div>
                </div>
            </nav>


            <div className="hero-wrap js-fullheight" id="b_header" style={{ height: 250 }}>
                {/* <div className="overlay"></div> */}
                {/* <div className="container">
          <div className="row no-gutters slider-text js-fullheight align-items-center" data-scrollax-parent="true">
            <div className="col-md-7 ">
              <span className="subheading">Welcome to Pacific</span>
              <h1 className="mb-4">Discover Your Favorite Place with Us</h1>
              <p className="caps">Travel to the any corner of the world, without going around in circles</p>
            </div>
            <a href="https://vimeo.com/45830194" className="icon-video popup-vimeo d-flex align-items-center justify-content-center mb-4">
              <span className="fa fa-play"></span>
            </a>
          </div>
        </div> */}
            </div>
        </>
    )
}

export default Header;